import React from 'react';
import { Section } from './Shared';
const costs: [string, string][] = [['Sin recetarios claros', 'Fórmulas que fallan = productos rechazados'], ['Sin cálculo de costos', 'Perdés dinero sin saberlo'], ['Sin branding profesional', 'No te compran por cómo se ve'], ['Sin estrategia de venta', 'Esperás a que te encuentren'], ['Sin consistencia en producción', 'Cada lote sale diferente'], ['Sin monetización de redes', 'Miles de seguidores, cero ventas']];
export function CostComparison() {
  return <Section data-id="element-17" data-mp="2ulhva81rp4hy">
      <div className="mb-10 text-center" data-id="element-18" data-mp="2ukydqsg14i4g">
        <h2 className="flex justify-center font-serif text-2xl font-bold text-brand-taupe md:text-4xl" data-id="element-19" data-mp="2pldj2u7w6vxj">
          <span className="mr-3" data-id="element-20" data-mp="2kmixxlmgcva9">⚖️</span>¿CUÁNTO CUESTA NO TENERLO?
        </h2>
      </div>
      <div className="mx-auto max-w-4xl" data-id="element-21" data-mp="1e66ylh7w97d3">
        <div className="mb-4 hidden grid-cols-2 gap-4 px-4 font-serif text-lg font-bold md:grid" data-id="element-22" data-mp="1e6zvzrkyqkik">
          <span className="text-brand-taupe" data-id="element-23" data-mp="196c6xbgaodqz">Sin la Guía Definitiva</span>
          <span className="text-brand-goldDark" data-id="element-24" data-mp="2la9c9u0g5ksn">Consecuencia real</span>
        </div>
        <div className="space-y-3" data-id="element-25" data-mp="2pc4agpn2zi27">
          {costs.map(([without, result]) => <div key={without} className="paper-panel grid gap-2 rounded-xl p-4 md:grid-cols-2 md:gap-4 md:p-5" data-id="element-26" data-mp="2pa1m0a1ktwzl">
              <p className="text-sm font-semibold text-brand-text" data-id="element-27" data-mp="2gbfuhpe4n7mo">{without}</p>
              <p className="text-sm font-medium text-brand-sageMid" data-id="element-28" data-mp="2gdiv13cwoj5n">
                <span className="mr-2 text-brand-goldDark md:hidden" data-id="element-29" data-mp="21l8o481e9f2c">→</span>
                {result}
              </p>
            </div>)}
        </div>
      </div>
      <div className="mx-auto mt-12 max-w-3xl rounded-2xl border border-brand-sage/40 bg-brand-sageMist/70 p-8 text-center" data-id="element-30" data-mp="1smwoxhmgp8ya">
        <p className="font-display text-xl font-semibold italic leading-relaxed text-brand-sageMid md:text-2xl" data-id="element-31" data-mp="1xlq0h4i6upvt">
          “La emprendedora que tiene un sistema fabrica con confianza. La que fabrica con confianza presenta mejor. La
          que presenta mejor cobra premium.”
        </p>
        <p className="mt-4 text-lg" data-id="element-32" data-mp="14j730hehqe48">🌿</p>
      </div>
    </Section>;
}